import {
  getAutoPlayNextControl,
  getTurnOffTimeControl,
  setTurnOffTimeControl,
} from '@/utils';

function resetTurnOffTimeControl() {
  const setting = {
    type: 'off',
    key: 'off',
    value: 'off',
  };
  setTurnOffTimeControl(setting);
}

class AutoNextSettings {
  constructor() {
    this.autoNext = false;
  }

  get() {
    return this.autoNext;
  }

  set(value) {
    this.autoNext = value;
  }

  update(finishedCount) {
    const autoNextSetting = getAutoPlayNextControl();
    const turnOffSetting = getTurnOffTimeControl();
    // 不开启自动连续播放
    if (autoNextSetting === 'off') {
      this.set(false);
      return;
    }
    // 已开启自动连续播放
    const { type: turnOffType, value: turnOffValue } = turnOffSetting;
    // 不设置定时关闭
    if (turnOffType === 'off') {
      this.set(true);
      return;
    }
    // 根据时间定时关闭
    if (turnOffType === 'time') {
      const now = new Date().getTime();
      if (now >= turnOffValue) {
        this.set(false);
        // 重置定时关闭设置
        resetTurnOffTimeControl();
        return;
      }
    }
    // 根据播完栏目数定时关闭
    if (turnOffType === 'program') {
      if (finishedCount >= turnOffValue) {
        this.set(false);
        // 重置定时关闭设置
        resetTurnOffTimeControl();
        return;
      }
    }
    this.set(true);
  }
}

export default AutoNextSettings;
